// stores/screen.js - 화면 전환 상태 관리
import { writable } from 'svelte/store';

/**
 * @typedef {'landing' | 'pairing' | 'linkConfirm' | 'camera' | 'thumbnails' | 'uploading' | 'complete' | 'settings' | 'error' | 'cameraPermission'} ScreenName
 */

/** 현재 화면 */
export const currentScreen = writable(null);

/** 이전 화면 (뒤로가기용) */
export const previousScreen = writable(null);

/** 업로드 진행률 (0-100) */
export const uploadProgress = writable(0);

/** 업로드 상태 메시지 */
export const uploadStatus = writable('');

/**
 * 화면 전환
 * @param {ScreenName} screen
 */
export function showScreen(screen) {
  currentScreen.update(current => {
    previousScreen.set(current);
    return screen;
  });
}

/**
 * 이전 화면으로 돌아가기
 */
export function goBack() {
  previousScreen.update(prev => {
    if (prev) {
      currentScreen.set(prev);
    }
    return null;
  });
}

/**
 * 현재 화면 가져오기 (store 외부에서 사용)
 * @returns {ScreenName | null}
 */
export function getCurrentScreen() {
  let screen = null;
  currentScreen.subscribe(s => screen = s)();
  return screen;
}
